import { render, staticRenderFns } from "./RegisterFormComponent.vue?vue&type=template&id=5883e4ae&scoped=true"
import script from "./RegisterFormComponent.vue?vue&type=script&lang=js"
export * from "./RegisterFormComponent.vue?vue&type=script&lang=js"
import style0 from "./RegisterFormComponent.vue?vue&type=style&index=0&id=5883e4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5883e4ae",
  null
  
)

export default component.exports